import { Component, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';
import { AiReadFile } from 'src/app/aplication/api/Manipulate/Ai';
import { Message, User } from 'src/app/aplication/api/Manipulate/Chat';
import { FileUploadDto } from 'src/app/aplication/api/Manipulate/File';
import { OfferItemDto } from 'src/app/aplication/api/Manipulate/OfferItem';
import { UserDto } from 'src/app/aplication/api/Manipulate/UserDto';
import { AIService } from 'src/app/aplication/api/Services/AI.service';
import { ChatSignalService } from 'src/app/aplication/api/Services/Chat.service';
import { ChatLummySignalService } from 'src/app/aplication/api/Services/ChatLummy.service';
import { ChatRagSignalService } from 'src/app/aplication/api/Services/ChatRag.service';
import { ChatService } from 'src/app/aplication/api/Services/ChatService';

@Component({
  selector: 'app-chat-ai-open',
  templateUrl: './chat-ai-open.component.html',
  styleUrl: './chat-ai-open.component.scss'
})
export class ChatAiOpenComponent {
  private _infoPath !: AiReadFile;
  public get infoPath() : AiReadFile {
    return this._infoPath;
  }
  @Input() public set infoPath(v : AiReadFile) {
    this._infoPath = v;
  }

  private _modeSelected : number = 1;
  public get modeSelected() : number {
    return this._modeSelected;
  }
  @Input() public set modeSelected(v : number) {
    this._modeSelected = v;

  }
  private _myUser !: UserDto;
  public get myUser() : UserDto {
    return this._myUser;
  }
  @Input() public set myUser(v : UserDto) {
    this._myUser = v;
    if(v){
      if(this.myUser.profilePhoto){
        this.userPicture = `data:image/png;base64,${this.myUser.profilePhoto}`;
      }
    }
  }

  private _pdfUrl!: string;
  public get pdfUrl() : string {
    return this._pdfUrl;
  }
  @Input()  set pdfUrl(v : string) {
    this._pdfUrl = v;
    // this.setarTemaChat();
    // this.configMessager();
  }
  private subscriptions: Subscription[] = [];


  public userPicture !:string;
  botAtivado:boolean = true;
  defaultUserId: number = 1;
  private _temaSubscription?: Subscription;

  public arquivosUpload: FileUploadDto = new FileUploadDto();
  message!: Message;
  private _tema : string = 'light';
  public get tema() : string {
      return this._tema;
  }
  public set tema(v : string) {
      this._tema = v;
      // //console.warn("o novo tema é" + v);
  }
  activeUser!: User;
  textContent: string = '';
  targetProductList:OfferItemDto[] = [];
  animationLoader: AnimationOptions = {
    path: '../../../../../../../../assets/Animations/animationLoader.json',
  };
  loadingResponse: boolean = false;
  uploadedFiles: any[] = [];
  public loaded:boolean = false;
  // subscription: Subscription;
  emojis = [
      '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😊', '🙂', '🙃', '😋', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '🤪', '😜', '😝', '😛',
      '🤑', '😎', '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐', '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳', '😞', '😟', '😠', '😡', '🤬', '😔',
      '😟', '😠', '😡', '🤬', '😔', '😕', '🙁', '😬', '🥺', '😣', '😖', '😫', '😩', '🥱', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤'
  ];

  user: User = new User();
  bot: User = new User();
  animationLoading: AnimationOptions = {
    path: 'assets/Animations/animationAi.json',
  };
  constructor(
    private _aiService:AIService,
    protected _lummy: ChatLummySignalService
  ) {
      // this.subscription = this._chatService.activeUser$.subscribe(data => this.activeUser = data);
      // this._chatService.activeUser$.subscribe(user => {
      //     this.activeUser = user;
      // });
  }

  ngOnInit(): void {
    this.setarTemaChat();
    this.configMessager();
  }

  setInitialValuesByMode(){
    const mode = this.modeSelected;
    switch(mode){
      case 1:
        this.setInitialValues();
        this.receiveMessage('Olá como posso te ajudar hoje?');
        break;
      case 2:
        this.setInitialValues();
        // this._chatSignalService.initializeConnection();
        this.configMessager();
        break;
      case 3:
        this.setInitialValues();
        this.receiveMessage('Analizando os documentos necessários para a sua habilitação...');
        this.listDocuments();
        break;
    }
  }

  setInitialValues(){
    this.user = new User();
    this.user.id = 1;
    this.user.name = 'Usuario';
    this.user.image = 'assets/images/user.png';
    this.user.status = 'online';
    this.user.lastSeen = 'online';
    this.user.messages = [];

    this.bot = new User();
    this.bot.id = 2;
    this.bot.name = 'Lummy';
    this.bot.image = 'assets/images/bot.png';
    this.bot.status = 'online';
    this.bot.lastSeen = 'online';
    this.bot.messages = [];

  }

  onFileSelect(event: any) {
    const selectedFiles: File[] = event.currentFiles;
    this.arquivosUpload.files = selectedFiles;
    //console.log(selectedFiles);
  }

  setarTemaChat(){
      var temaStorage = localStorage.getItem('KatiaColor');
      if(temaStorage){
          this.tema = temaStorage;
      }
  }

  sendMessage() {
    if (this.textContent === '' || this.textContent === ' ') {
      return;
    }

    const message: Message = {
      text: this.textContent,
      ownerId: this.user.id,
      createdAt: new Date().getTime()
    };

    // Adiciona a mensagem do usuário ao chat
    this.user.messages.push(message);

    // Envia a mensagem para o SignalR e GPT através do backend
    this._lummy.sendMessage(this.user.id.toString(), this.textContent);

    // Limpa o campo de mensagem e inicia o loading
    this.textContent = '';
    this.loadingResponse = true;
  }

  configMessager() {
    this._lummy.initializeConnection();
    this._lummy.onReceiveMessage((user, message) => {
      this.receiveMessage(message);  // Mostra a mensagem do GPT no chat
    });

  }

  receiveMessage(message: string) {
    this.loadingResponse = false;
    const messageBot: Message = {
      text: message, // Inicia com texto vazio para simular o efeito de digitação
      ownerId: 2,
      createdAt: new Date().getTime()
    };

    // Adiciona a mensagem vazia ao array
    this.user.messages.push(messageBot);
    // Simular a digitação, preenchendo a mensagem gradualmente
    // this.simulateTyping(message, messageBot);
  }

  simulateTyping(message: string, messageBot: Message) {
    let index = 0;

    const interval = setInterval(() => {
      if (index < message.length) {
        // Adiciona um caractere por vez à mensagem que já está no array
        messageBot.text += message[index];
        index++;
      } else {
        clearInterval(interval); // Para quando toda a mensagem for exibida
        // Desativa o loading quando a mensagem for exibida
      }
    }, 2); // 50ms de intervalo para o efeito de digitação
  }
  onEmojiSelect(emoji: string) {
      this.textContent += emoji;
  }

  parseDate(timestamp: number) {
      return new Date(timestamp).toTimeString().split(':').slice(0, 2).join(':');
  }

  setarTema(){
      var theme = localStorage.getItem('KatiaColor')?.toString()
      if(theme)
       this.tema = theme;
  }
  ngOnDestroy() {
    this._lummy.stopChatConnection();
    if(this._temaSubscription)
          this._temaSubscription.unsubscribe();
    this._lummy.stopChatConnection();
  }
  listDocuments(){
    var folderPath
    if(this.infoPath.folderPath){
      folderPath = this.infoPath.folderPath.replace('//','/');
      folderPath = folderPath.replace('///','/');
      folderPath = folderPath.replace(/\/\//g, '/');
    }
    if(this.infoPath.fileName && folderPath)
    {
      setTimeout(() => {
        this.loadingResponse = true;
      }, 700);
      this._aiService.GetInfoDocumentsByBlobPath(folderPath,this.infoPath.fileName).subscribe({
        next: (response) => {
          if (response.message) {
            // Simula o efeito de digitação com um delay
            const formattedMessage = response.message.replace(/ - /g, '<br>- ').replace(/(\d+)/g, '<br>$1').replace('-', '<br>- ');
            this.receiveMessage(formattedMessage)
            //console.log(formattedMessage);
          }
        },
        error: (error) => {
          this.loadingResponse = false;
          // this.desabledTextArea= false;
          this.receiveMessage('Houve um erro ao analizar arquivo')

          console.error('Erro ao analizar arquivo', error);
        },
        complete: () => {
          this.loadingResponse = false;
          // Ação a ser realizada após a finalização do processo
        }
      });
    }
  }
}
